const FormResult = ({status, text}) => {
    return (
        <div className="result">
            <p className="result__title h2">{status}</p>
            <p>{text}</p>
        </div>
    )
};
export default FormResult;